module.exports = __webpack_public_path__ + "img/cooperation_img.3f122564.png";